import { excludeParticipant } from '@/api/project';
import { handleError } from '@/actions/common';
import store from '@/state/store';
import projectSlice from '@/state/project.slice';
import { Invitation } from '@/state/types/invitation';
import { runBulk } from '../utils';

export default async (code: string, invitations: Invitation[]): Promise<void> => {
  try {
    const ids = await runBulk(
      invitations,
      (invitation) => excludeParticipant(
        code,
        typeof invitation.participant === 'string' ? invitation.participant : invitation.participant.id
      ).then(() => invitation.id),
      (e) => handleError(e)
    );
    
    store.dispatch(
      projectSlice.actions.removeInvitations({
        code,
        ids,
      })
    );
  } catch (error) {
    handleError(error);
    throw error;
  }
};